import type { ClientSentimentDTO, SentimentLevel } from '@copilot/shared';
import { Link } from 'react-router';
import { cn } from '../../lib/cn';
import { formatDate } from '../../lib/format';
import { SENTIMENT_LABELS } from '../../lib/labels';

/** Height shows strength, color and shape show direction (negative bars are square-cornered). */
const BARS: Record<SentimentLevel, string> = {
  very_positive: 'h-full rounded-md bg-good',
  positive: 'h-1/2 rounded-md bg-good',
  neutral: 'h-1/4 rounded-md bg-line-strong',
  negative: 'h-1/2 rounded-[2px] bg-danger',
  very_negative: 'h-full rounded-[2px] bg-danger',
  unknown: 'h-1/4 rounded-md bg-line-strong',
};

/** One bar per recent meeting, oldest on the left. */
export function SentimentTrend({ history }: { history: ClientSentimentDTO['history'] }) {
  const oldestFirst = [...history].reverse();
  return (
    <ol
      className="flex h-12 items-end gap-1.5"
      aria-label="Sentiment of recent meetings, oldest first"
    >
      {oldestFirst.map((h) => {
        const label = `${SENTIMENT_LABELS[h.level]}, ${formatDate(h.startedAt)}`;
        return (
          <li key={h.meetingId} className="flex h-full max-w-6 flex-1 items-end">
            <Link
              to={`/meetings/${h.meetingId}`}
              title={label}
              aria-label={label}
              className={cn(
                'grow-y block w-full min-w-2 transition-opacity hover:opacity-75 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent',
                BARS[h.level],
              )}
            />
          </li>
        );
      })}
    </ol>
  );
}
